<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 联系我们
 * @Date: 2021-09-08 14:28:00
 * @LastEditTime: 2022-02-08 13:47:15
-->

<template>
  <van-action-sheet v-model:show="state.isShow" title="Contact Us">
    <div class="pay-message">
      <div class="pay-contact-way">
        <span>
          <img src="images/payTypes/Email.svg" alt="" class="email img-center">
        </span>
        <span class="ml-5">
          Email:<a
            class="pay-interlinkage"
            href="mailto:support@asoworld.com"
          >support@asoworld.com</a>
        </span>
      </div>
      <div class="pay-contact-way">
        <span>
          <img src="images/payTypes/WhatsApp.svg" alt="">
        </span>
        <span class="ml-5">
          WhatsApp/Telegram:<a
            class="pay-interlinkage"
            href="https://api.whatsapp.com/send?phone=+85253450602&text=Hello"
            target="_blank"
          >+852 5345 0602</a>
        </span>
      </div>
      <div class="pay-contact-way">
        <span>
          <img src="images/payTypes/Skype.svg" alt="">
        </span>
        <span class="ml-5">
          Skype:
          <a
            class="pay-interlinkage"
            href="https://join.skype.com/invite/uPnOfd0H82Gk"
            target="_blank"
          >live:.cid.53bc0d33f78af5e9</a>
        </span>
      </div>
    </div>
  </van-action-sheet>
</template>

<script>
import {reactive} from "vue"
export default {
  setup(){
    const state = reactive({
      isShow :false
    })
    
    const open = ()=>{
      state.isShow = true
    }

    return {
      state,open
    }

  }
}

</script>
<style lang="scss" scoped>
.pay-message {
  width: 90%;
  margin: 0 auto;

  .pay-contact-way {
    display: flex;
    align-items: center;
    border-top: 1px solid  #EBEEF5;
    padding: 15px 0;

    span{
      .img-center {
        margin-top: 3px;
      }
    }
  }
}

</style>